export const queryKeys = {
  campaignPlanners: "campaignPlanners",
};
